




import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import AppBase from '@/views/AppBase.vue';

@Component({
  components: {
    AppBase,
  },
})
export default class App extends Vue { }
